module.exports = __webpack_public_path__ + "static/img/right.ee62838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 14 17